import { render, staticRenderFns } from "./sortRank.vue?vue&type=template&id=4c358051&scoped=true&"
import script from "./sortRank.vue?vue&type=script&lang=js&"
export * from "./sortRank.vue?vue&type=script&lang=js&"
import style0 from "./sortRank.vue?vue&type=style&index=0&id=4c358051&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c358051",
  null
  
)

export default component.exports